export const faqData = [
  {
    id: 1,
    question: "Can MinEMI help me find lenders even with a low credit score?",
    answer:
      "Yes, MinEMI matches you with lenders that cater to all credit profiles. Our experts help you identify options even with a sub-optimal credit score.",
  },
  {
    id: 2,
    question: "How much can I save with MinEMI’s Balance Transfer?",
    answer:
      "Savings depend on your current interest rate and the new lender’s offer. Use the MinEMI Balance Transfer Calculator to see your personalized savings instantly.",
  },
  {
    id: 3,
    question: "Can I transfer my partially paid loan?",
    answer:
      "Absolutely. MinEMI’s platform simplifies the process of transferring partially paid loans.",
  },
  {
    id: 4,
    question: "Are there any hidden charges?",
    answer:
      "MinEMI ensures transparency by listing all processing fees, prepayment penalties, and other charges before you proceed.",
  },
];
